<template>
    <div class="text-center">
        <v-icon v-if="!!isEmptyComment && !!canEdit" small @click="editComment" title="Оставить комментарий">mdi-chat-processing</v-icon>
        <v-icon v-else-if="!isEmptyComment" small color="success" @click="editComment">mdi-chat-processing</v-icon>
        <v-dialog v-model="editDialog" @keydown.esc="editDialog = false" @click:outside="editDialog = false" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span v-if="!showAdminUI" class="headline">Редактировать комментарий</span>
                    <span v-else class="headline">Комментарий СТО</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea v-if="!!canEdit && stage !== 'C30:WON'" v-model="comment" placeholder="Текст комментария от руководителя СТО или менеджера сопровождения" required></v-textarea>
                                <div v-else>{{ comment }}</div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" v-if="!!showFranch || !!showAccount" text @click="saveComment">Сохранить</v-btn>
                    <v-btn color="blue darken-1" v-else text @click="editDialog = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  export default {
    name: 'stoCommentEditor',
    props: ['value', 'mode', 'stage'],
    data () {
      return {
        comment: this.value,
        editDialog: false,
        viewDialog: false,
        tempData: null,
      }
    },
    computed: {
      canEdit() {
        return (this.mode === 'franch' || this.mode === 'account' && this.stage === 'C30:1')
      },
      showAdminUI() {
        if(this.mode) {
          return this.mode === 'manager'
        } else {
          return false
        }
      },
      showFranch() {
        if(this.mode) {
          return this.mode === 'franch'
        } else {
          return false
        }
      },
      showAccount() {
        if(this.mode) {
          return this.mode === 'account'
        } else {
          return false
        }
      },
      showUK() {
        if(this.mode) {
          return this.mode === 'uk'
        } else {
          return false
        }
      },
      isEmptyComment () {
        return this.comment === null || this.comment === '' || this.comment.replace(/ /g, '') === '' || this.comment === undefined
      }
    },
    filters: {},
    methods: {
      saveComment() {
        this.editDialog = false
        if(this.tempData !== this.comment) {
          this.change()
        }
        this.tempData = null
      },
      change () {
        this.$emit('input', this.comment)
        this.$nextTick(function () {
          this.$emit('change')
        })

      },
      editComment () {
        this.tempData = JSON.parse(JSON.stringify(this.comment))
        this.editDialog = true
      }
    },
  }
</script>

<style scoped>

</style>